import {customEvent} from "../../webpack/modules/events";
import {hideElement, showElement} from "../../webpack/modules/element-visibility";
import {isMobile, isTablet} from "../../webpack/modules/devices";
import {deferTask} from "../../webpack/modules-optimized/defer";

deferTask(function () {
    let whatsappKey = document.querySelector('#whatsapp-key');
    let isThankUPage = document.getElementById('thank-u-page');
    if (isThankUPage || !whatsappKey || !(isMobile() || isTablet())) return;

    let script = document.createElement('script');
    script.setAttribute('src', 'https://widget.tochat.be/bundle.js');
    script.dataset.key = whatsappKey.value;
    document.head.appendChild(script);

    let helpWidgetType = document.getElementById('help-widget-type');
    if (helpWidgetType) helpWidgetType.dataset.type = 'whatsapp';
});

customEvent('show.bs.offcanvas', '.offcanvas', false, function() {
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) hideElement(chatWidget);
    let tawkWidgets = document.querySelectorAll('.widget-visible iframe');
    if (tawkWidgets) {
        tawkWidgets.forEach(function (widget, index) {
            if (index === 0 || index === 4) hideElement(widget);
        });
    }
});

customEvent('hidden.bs.offcanvas', '.offcanvas', false, function() {
    let chatWidget = document.querySelector('.chatwithapp');
    if (chatWidget) showElement(chatWidget);
    let tawkWidgets = document.querySelectorAll('.widget-visible iframe');
    if (tawkWidgets) {
        tawkWidgets.forEach(function (widget, index) {
            if (index === 0 || index === 4) showElement(widget);
        });
    }
});
